import ProductsPage from '../products/ProductsPage';

/** 底部導覽「行情」頁 */
export default function MarketPage() {
  return <ProductsPage title="行情" showClose={false} />;
}
